import { QueovalBase, QueovalDik } from "../global";

export class AccesPortailModel extends QueovalBase {
  constructor() {
    super();
      this.Success = false;
      this.idPersonne = '';
      this.Conx_PER = new QueovalDik('', '');
      this.PassePER = new QueovalDik('', '');
      this.Role_PER = new QueovalDik('', '');
      this.NeproPER = new QueovalDik('', '');
      this.ComboRole_PER = new Map<string, string>();
    
  }
  public Success: boolean;
  public idPersonne: string;
  public Conx_PER: QueovalDik;
  public PassePER: QueovalDik;
  public Role_PER: QueovalDik;
  public NeproPER: QueovalDik
  public ComboRole_PER: Map<string, string>;
}
